import { React } from 'react';
import styled from 'styled-components';
import LocationModel from '../../Model/Individual/RulesModel/LocationModel';

function LocationPage() {

  return (
    <Container>
      <LocationModel/>
    </Container>
  )
}

export default LocationPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100vw;
`;